export const getFirstPaymentType = () => {
    const paymentTypes = process.env.paymentTypes.split('|')

    return paymentTypes[0]
}
